module.exports = __webpack_public_path__ + "img/q_6_sor.2379ec42.png";